import useFlag from 'hooks/useFlag'
import {
  usePermissionReason,
  useRbacNavDisabledWithReason,
} from 'hooks/useRbacNavCheck'
import { buildTranslate } from 'locales'
import { useAbility } from 'utilities/ability'
import NavLink from '../Bar/NavLink'

const t = buildTranslate('nav.rewards_menu')

type RewardsContentProps = {
  isLeftNav?: boolean
  onClick?: () => void
}

const RewardsContent = ({
  isLeftNav = false,
  onClick = () => {},
}: RewardsContentProps) => {
  const ability = useAbility()
  const games = useRbacNavDisabledWithReason('Games')
  const promoCodes = useRbacNavDisabledWithReason('Promotions')
  const gamificationManagementEnabled = useFlag(
    'gamification-management-enabled',
    false
  )
  const promoCodesEnabled = useFlag('mx-universal-promo-codes', false)

  const rewardsDisabled = ability.cannot('access', 'RedeemManager')
  const rewardsReason = usePermissionReason('RedeemManager', rewardsDisabled)

  const rewardActivityDisabled =
    ability.cannot('access', 'LocationReports') &&
    ability.cannot('access', 'RewardRedemptions')
  const rewardActivityReason = usePermissionReason(
    'LocationReports',
    rewardActivityDisabled
  )

  return (
    <>
      <NavLink
        isLeftNav={isLeftNav}
        onClick={onClick}
        text={t('rewards')}
        link="/rewards"
        disabled={rewardsDisabled}
        disabledReason={rewardsReason}
      />
      <NavLink
        isLeftNav={isLeftNav}
        onClick={onClick}
        link={'/reports/reward_activity'}
        text={t('reward_activity')}
        disabled={rewardActivityDisabled}
        disabledReason={rewardActivityReason}
      />
      {promoCodesEnabled && (
        <NavLink
          isLeftNav={isLeftNav}
          onClick={onClick}
          text={t('promo_codes')}
          link="/promo_codes"
          disabled={promoCodes.disabled}
          disabledReason={promoCodes.disabledReason}
        />
      )}
      {gamificationManagementEnabled && (
        <NavLink
          isLeftNav={isLeftNav}
          onClick={onClick}
          text={t('games')}
          link="/games"
          status="beta"
          disabled={games.disabled}
          disabledReason={games.disabledReason}
        />
      )}
    </>
  )
}

export default RewardsContent
